var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5146 4.08013C17.3211 2.87039 16.4539 1.25 15 1.25C13.5461 1.25 12.6789 2.87039 13.4854 4.08013C13.502 4.10506 13.5191 4.12942 13.5366 4.1532C10.6114 4.77538 8.36195 7.22477 8.03971 10.25H8C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75H22C22.4142 11.75 22.75 11.4142 22.75 11C22.75 10.5858 22.4142 10.25 22 10.25H21.9603C21.6381 7.22477 19.3886 4.77538 16.4634 4.1532C16.4809 4.12942 16.498 4.10506 16.5146 4.08013ZM14.7334 3.24808C14.5915 3.03517 14.7441 2.75 15 2.75C15.2559 2.75 15.4085 3.03517 15.2666 3.24808C15.1398 3.43829 14.8602 3.43829 14.7334 3.24808Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37549 21.2813C11.9057 22.0159 14.6039 21.9654 17.111 21.1297L20.8897 19.8701C21.5528 19.6491 22 19.0286 22 18.3297C22 17.2733 21.0073 16.4982 19.9824 16.7544L17.6228 17.3443L15.2563 18.2048C14.867 18.3464 14.4367 18.1456 14.2952 17.7563C14.1536 17.367 14.3544 16.9367 14.7437 16.7952L17.1179 15.9318C16.8929 15.2604 16.317 14.7195 15.549 14.5915L14.9795 14.4966C13.1183 14.1864 11.2132 14.2852 9.39619 14.7848C9.46373 15.0114 9.5 15.2515 9.5 15.5V20.5C9.5 20.7729 9.45629 21.0355 9.37549 21.2813Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.5C2 14.9477 2.44772 14.5 3 14.5H7C7.55228 14.5 8 14.9477 8 15.5V20.5C8 21.0523 7.55228 21.5 7 21.5H3C2.44772 21.5 2 21.0523 2 20.5V15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceAlt);
export default __webpack_public_path__ + "static/media/service-alt.d1333941615cc295025686c9c3b6797d.svg";
export { ForwardRef as ReactComponent };